import { getStateColors } from './icon_helpers';

/**
 * Creates a hazards risk areas - bee and pollination zones icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createBeeAndPollinationZonesIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- hazards risk areas - bee and pollination zones icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<ellipse fill="${colors.iconColor}" cx="12" cy="13" rx="4" ry="5" /><path fill="${colors.iconColor}" d="M10 11h4M10 13h4M10 15h4" /><circle fill="${colors.iconColor}" cx="12" cy="8" r="2" /><path fill="${colors.iconColor}" d="M8 10c-2-1-3-2-3-3M16 10c2-1 3-2 3-3" /><path fill="${colors.iconColor}" d="M9 13l-3 2M15 13l3 2" /><circle fill="${colors.iconColor}" cx="11" cy="8" r="0.6" /><circle fill="${colors.iconColor}" cx="13" cy="8" r="0.6" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a hazards risk areas - biosecurity checkpoints icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createBiosecurityCheckpointsIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- hazards risk areas - biosecurity checkpoints icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<path fill="${colors.iconColor}" d="M12 2l-8 4v6c0 5 3.5 8.5 8 10 4.5-1.5 8-5 8-10V6l-8-4z" /><path fill="none" stroke="${colors.iconColor}" stroke-width="2" d="M12 6v12M8 9l4 4 4-4" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a hazards risk areas - chemical storage icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createChemicalStorageIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- hazards risk areas - chemical storage icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<path fill="${colors.iconColor}" d="M12 2L8 8v8c0 2.2 1.8 4 4 4s4-1.8 4-4V8l-4-6zm0 16c-1.1 0-2-.9-2-2V9l2-3 2 3v7c0 1.1-.9 2-2 2z" /><path fill="${colors.iconColor}" d="M9 12h6M9 14h6" /><circle fill="${colors.iconColor}" cx="10" cy="16" r="0.8" /><circle fill="${colors.iconColor}" cx="14" cy="16" r="0.8" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a hazards risk areas - confined space icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createConfinedSpaceIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- hazards risk areas - confined space icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="4" y="8" width="16" height="13" rx="1" /><circle fill="none" stroke="${colors.iconColor}" stroke-width="2" cx="12" cy="14" r="2.5" /><rect fill="${colors.iconColor}" x="8" y="3" width="8" height="5" /><rect fill="${colors.iconColor}" x="10" y="1" width="4" height="2" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a hazards risk areas - fire risk zones icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createFireRiskZonesIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- hazards risk areas - fire risk zones icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<path fill="${colors.iconColor}" d="M12 2c-2 3-3 6-3 8 0 3 1.5 5 3 5s3-2 3-5c0-2-1-5-3-8z" /><path fill="${colors.iconColor}" d="M9 10c-1 1-2 2-2 3 0 1.5 1 2.5 2 2.5M15 10c1 1 2 2 2 3 0 1.5-1 2.5-2 2.5" /><path fill="${colors.iconColor}" d="M8 18h8v1H8zM9 19.5h6v1H9zM10 21h4v1h-4z" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a hazards risk areas - fuel storage icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createFuelStorageIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- hazards risk areas - fuel storage icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="5" y="4" width="10" height="16" rx="1" /><rect fill="none" stroke="${colors.iconColor}" stroke-width="2" x="7" y="7" width="6" height="5" /><rect fill="${colors.iconColor}" x="7" y="14" width="6" height="2" /><path fill="${colors.iconColor}" d="M15 9h2v2c0 1 .5 1.5 1 1.5s1-.5 1-1.5V9c0-1-.5-2-1.5-2S16 8 16 9" /><circle fill="${colors.iconColor}" cx="18.5" cy="8" r="1" /><rect fill="${colors.iconColor}" x="8" y="2" width="5" height="2" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a hazards risk areas - high traffic zone icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createHighTrafficZoneIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- hazards risk areas - high traffic zone icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<path fill="${colors.iconColor}" d="M12 3L3 7v2h18V7z" /><rect fill="${colors.iconColor}" x="7" y="9" width="3" height="6" /><rect fill="${colors.iconColor}" x="14" y="9" width="3" height="6" /><rect fill="${colors.iconColor}" x="5" y="15" width="5" height="2" /><rect fill="${colors.iconColor}" x="14" y="15" width="5" height="2" /><rect fill="${colors.iconColor}" x="2" y="18" width="20" height="3" /><circle fill="none" stroke="${colors.iconColor}" stroke-width="1.5" cx="5" cy="19.5" r="0.8" /><circle fill="none" stroke="${colors.iconColor}" stroke-width="1.5" cx="12" cy="19.5" r="0.8" /><circle fill="none" stroke="${colors.iconColor}" stroke-width="1.5" cx="19" cy="19.5" r="0.8" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a hazards risk areas - machinery zone icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createMachineryZoneIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- hazards risk areas - machinery zone icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<circle fill="${colors.iconColor}" cx="7" cy="16" r="3.5" /><circle fill="none" stroke="${colors.iconColor}" stroke-width="1.5" cx="7" cy="16" r="1.5" /><circle fill="${colors.iconColor}" cx="17" cy="16" r="3.5" /><circle fill="none" stroke="${colors.iconColor}" stroke-width="1.5" cx="17" cy="16" r="1.5" /><rect fill="${colors.iconColor}" x="10" y="15" width="4" height="2" /><path fill="${colors.iconColor}" d="M5 12h14c1 0 2-1 2-2V8c0-1-1-2-2-2H5c-1 0-2 1-2 2v2c0 1 1 2 2 2z" /><rect fill="none" stroke="${colors.iconColor}" stroke-width="1.5" x="7" y="8" width="3" height="2" /><rect fill="none" stroke="${colors.iconColor}" stroke-width="1.5" x="14" y="8" width="3" height="2" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a hazards risk areas - overhead powerlines icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createOverheadPowerlinesIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- hazards risk areas - overhead powerlines icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="3" y="8" width="18" height="2" /><rect fill="${colors.iconColor}" x="3" y="12" width="18" height="2" /><rect fill="${colors.iconColor}" x="6.5" y="8" width="1.5" height="14" /><rect fill="${colors.iconColor}" x="11.25" y="8" width="1.5" height="14" /><rect fill="${colors.iconColor}" x="16" y="8" width="1.5" height="14" /><path fill="${colors.iconColor}" d="M5 6l2-4 2 4M10 6l2-4 2 4M15 6l2-4 2 4" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a hazards risk areas - pesticide herbicide area icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createPesticideHerbicideAreaIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- hazards risk areas - pesticide herbicide area icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="9" y="2" width="6" height="2" /><path fill="${colors.iconColor}" d="M15 4H9L8 7h8z" /><rect fill="${colors.iconColor}" x="8" y="7" width="8" height="11" rx="1" /><rect fill="${colors.iconColor}" x="9.5" y="18" width="1.5" height="4" /><rect fill="${colors.iconColor}" x="13" y="18" width="1.5" height="4" /><path fill="${colors.iconColor}" d="M12 9l-2 3h1v2h2v-2h1z" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a hazards risk areas - poisonous animal zones icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createPoisonousAnimalZonesIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- hazards risk areas - poisonous animal zones icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<path fill="${colors.iconColor}" d="M12 4c-3 0-5 2-5 5v3c0 2 1 3 2 4l-2 4h2l1.5-3h3l1.5 3h2l-2-4c1-1 2-2 2-4V9c0-3-2-5-5-5z" /><circle fill="none" stroke="${colors.iconColor}" stroke-width="1.5" cx="10" cy="10" r="1" /><circle fill="none" stroke="${colors.iconColor}" stroke-width="1.5" cx="14" cy="10" r="1" /><path fill="${colors.iconColor}" d="M10 13c.5.5 1.5 1 2 1s1.5-.5 2-1" /><path fill="${colors.iconColor}" d="M8 7l-2-2M16 7l2-2" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a hazards risk areas - slippery or uneven ground icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createSlipperyOrUnevenGroundIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- hazards risk areas - slippery or uneven ground icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<circle fill="${colors.iconColor}" cx="10" cy="4" r="2" /><path fill="${colors.iconColor}" d="M9 7l-2 4 2 1 1 4-2 2.5 1.5 1.5 3-3.5-.5-4 2.5-1L13 7z" /><path fill="${colors.iconColor}" d="M15 8l2-2" /><path fill="${colors.iconColor}" d="M3 18c1-.8 2-1.2 3-.8s2 .8 3 .8 2-.4 3-.8 2-.4 3-.8 2 .4 3 .8 2 .4 3 .8" /><path fill="${colors.iconColor}" d="M3 21c1-.8 2-1.2 3-.8s2 .8 3 .8 2-.4 3-.8 2-.4 3-.8 2 .4 3 .8 2 .4 3 .8" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a hazards risk areas - stockpile zones icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createStockpileZonesIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- hazards risk areas - stockpile zones icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="3" y="14" width="6" height="6" /><rect fill="${colors.iconColor}" x="9" y="14" width="6" height="6" /><rect fill="${colors.iconColor}" x="15" y="14" width="6" height="6" /><rect fill="${colors.iconColor}" x="6" y="8" width="6" height="6" /><rect fill="${colors.iconColor}" x="12" y="8" width="6" height="6" /><rect fill="${colors.iconColor}" x="9" y="2" width="6" height="6" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a hazards risk areas - water body dams icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createWaterBodyDamsIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- hazards risk areas - water body dams icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<path fill="${colors.iconColor}" d="M2 14c.5-1 1-2 2-2s1.5 1 2 2c.5 1 1 2 2 2s1.5-1 2-2c.5-1 1-2 2-2s1.5 1 2 2c.5 1 1 2 2 2s1.5-1 2-2c.5-1 1-2 2-2s1.5 1 2 2" /><path fill="${colors.iconColor}" d="M2 18c.5-1 1-2 2-2s1.5 1 2 2c.5 1 1 2 2 2s1.5-1 2-2c.5-1 1-2 2-2s1.5 1 2 2c.5 1 1 2 2 2s1.5-1 2-2c.5-1 1-2 2-2s1.5 1 2 2" /><path fill="${colors.iconColor}" d="M6 10l3-6h6l3 6" /><rect fill="${colors.iconColor}" x="9" y="7" width="6" height="2" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

export const hazardsriskareasIcons = {
  bee_and_pollination_zones: createBeeAndPollinationZonesIcon,
  biosecurity_checkpoints: createBiosecurityCheckpointsIcon,
  chemical_storage: createChemicalStorageIcon,
  confined_space: createConfinedSpaceIcon,
  fire_risk_zones: createFireRiskZonesIcon,
  fuel_storage: createFuelStorageIcon,
  high_traffic_zone: createHighTrafficZoneIcon,
  machinery_zone: createMachineryZoneIcon,
  overhead_powerlines: createOverheadPowerlinesIcon,
  pesticide_herbicide_area: createPesticideHerbicideAreaIcon,
  poisonous_animal_zones: createPoisonousAnimalZonesIcon,
  slippery_or_uneven_ground: createSlipperyOrUnevenGroundIcon,
  stockpile_zones: createStockpileZonesIcon,
  water_body_dams: createWaterBodyDamsIcon
};
